export default __webpack_public_path__ + "static/media/NunitoSans-Light.3bac38f7.woff";